<template>
  <div
    v-if="comment.user.id === user.id && comment.company.id === company.id"
    class="card"
  >
    <div class="card-body">
      <h4>{{ $t('myLogOffer.mnimTklifim') }}</h4>
      <hr>
      <div
        v-for="(p,i) in getLOGPrices(comment.commentData)"
        :key="i"
      >
        <div class="row">
          <div class="col-12">
            <strong>
              {{ p.product.name }}
            </strong>
            <br>
            <span> {{ p.product.count }} {{ p.product.unit }} </span>
          </div>
          <div class="col-12">
            <table class="table table-sm table-bordered table-striped">
              <tr
                v-for="(v,k) in p.price"
                :key="k"
              >
                <td>{{ getDeliveryTypeName(k) }}</td>
                <td>
                  <div v-if="v.price<=0">
                    -
                  </div>
                  <div v-else>
                    <strong>{{ $t('offerExtrasView.azn', {price: v.price}) }}</strong>
                  </div>
                </td>
                <td>
                  <div v-if="v.price<=0">
                    -
                  </div>
                  <div v-else>
                    <em>{{ getIsTaxIncluded(p.taxIncluded) }}</em>
                  </div>
                </td>
                <td>
                  <div v-if="v.price<=0">
                    -
                  </div>
                  <div v-else>
                    {{ $t('myLogOffer.gn', {day: v.day}) }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getDeliveryTypeName, getIsTaxIncluded} from "@/repositories/Utils";

export default {
  name: 'MyLOGOffer',
  props: {
    comment: {},
    products: {},
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      company: state => state.auth.company,
    }),
  },

  methods: {
    getIsTaxIncluded(value) {
      return getIsTaxIncluded(parseInt(value), this.i18n);
    },

    getDeliveryTypeName(key) {
      return getDeliveryTypeName(key);
    },

    getLOGPrices(commentData) {

      let prices = [];

      let json = JSON.parse(commentData);


      Object.keys(json.prices).forEach((k) => {
        prices.push({
          product: this.getProductById(k),
          price: json.prices[k],
        })
      })


      return prices;

    },

    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },
  }
}
</script>